export default "__VITE_ASSET__gs0zNHGK__"